/**
 * Contacts view — F9 evidence (lead graph).
 */

import { useState, useEffect } from "react";
import { getClients, applyMembrane } from "../lib/api-clients";

export function ContactsView({ isOperator }: { isOperator: boolean }) {
  const [contacts, setContacts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const clients = getClients();
    if (!clients) { setLoading(false); return; }
    clients.envoy.listContacts(search ? { search } : undefined)
      .then((res: any) => setContacts(applyMembrane(res?.contacts || res || [], isOperator)))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [isOperator, search]);

  if (loading) return <div className="loading">Loading contacts…</div>;

  return (
    <div className="view">
      <div className="view-header">
        <span className="eyebrow">Pipeline</span>
        <h1>Contacts</h1>
        <input
          className="text-input search-input"
          placeholder="Search contacts…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      {error && <div className="error-state">{error}</div>}
      {contacts.length === 0 ? (
        <div className="empty-state">No contacts yet. Upload a spreadsheet or add contacts from a campaign.</div>
      ) : (
        <table className="data-table">
          <thead><tr><th>Name</th><th>Email</th><th>Company</th><th>Status</th><th>Tags</th></tr></thead>
          <tbody>
            {contacts.map((c: any, i: number) => (
              <tr key={i}>
                <td>{c.name || "—"}</td>
                <td>{c.email || "—"}</td>
                <td>{c.company || "—"}</td>
                <td><span className="badge" data-status={c.status || "pending"}>{c.status || "new"}</span></td>
                <td>{(c.tags || []).join(", ") || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
